import { Box, Container, Stack, styled } from '@mui/material';
import { Outlet } from 'react-router-dom';
import BSSLogo from 'assets/bss-logo.png';
import CorporateBankingLogo from 'assets/corporate_banking.png';

const ImageStyle = styled('img')`
  width: 170px;
  height: auto;
  object-fit: contain;
`;

const BaseLayout = () => {
  return (
    <Box>
      <Container>
        <Stack direction="row" sx={{ justifyContent: 'space-between', my: 4.5 }}>
          <ImageStyle src={BSSLogo} alt="bss-logo" />
          <ImageStyle src={CorporateBankingLogo} alt="corporate banking logo" />
        </Stack>
        <Outlet />
      </Container>
    </Box>
  );
};

export default BaseLayout;
